
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

const ORDER_MGMT_TABS = [0, 5, 6, 7]

@Component({
  name: 'TabChange'
})
export default class extends Vue {
  @Prop({ default: '' }) orderStatics: any
  @Prop({ default: '' }) defaultActivity: any
  private activeIndex: number = 0

  @Watch('defaultActivity', { immediate: true })
  private onChange(val: any) {
    const n = Number(val)
    this.activeIndex = ORDER_MGMT_TABS.includes(n) ? n : 0
  }

  get changedOrderList() {
    return [
      {
        label: '全部订单',
        value: 0
      },
      {
        label: '已完成',
        value: 5
      },
      {
        label: '已取消',
        value: 6
      },
      {
        label: '已退款',
        value: 7
      }
    ]
  }

  private tabChange(activeIndex) {
    this.activeIndex = activeIndex
    this.$emit('tabChange', activeIndex)
  }
}
